import { useState, useMemo } from "react";
import { Button, Modal, Typography, ConfigProvider } from "antd";
import "./modal-form-button.css";
import CloseIcon from "../static/close-icon.svg";
import LazyFeedbackForm from "../feedback-form/lazy-feedback-form";

const ModalCloseIcon = () => {
  return (
    <div>
      <img width={"20px"} alt="Закрыть" src={CloseIcon} loading="lazy" />
    </div>
  );
};

export default function ModalFormButton({
  buttonText = "Кнопка",
  buttonClassName = "modal-button-base",
  modalTitle = "Заголовок",
  modalText = null,
  hasCenteredLayout = false,
  onSuccess = () => {},
  modalWidth = 1000,
}) {
  const [open, setOpen] = useState(false);

  const showModal = () => setOpen(true);
  const handleCancel = () => setOpen(false);

  const handleFormSuccess = () => {
    onSuccess();
    // setTimeout(handleCancel, 1000);
    handleCancel();
  };

  // Мемоизируем конфиг для ConfigProvider
  const configProviderTheme = useMemo(
    () => ({
      components: {
        Button: { colorPrimary: "#F67828" },
        Modal: { contentBg: "rgba(54,50,47, 1)" },
      },
    }),
    []
  );

  return (
    <>
      <ConfigProvider theme={configProviderTheme}>
        <Button
          className={`modal-button-base ${buttonClassName}`}
          onClick={showModal}
        >
          {buttonText}
        </Button>

        <Modal
          className={`modal-main ${hasCenteredLayout ? "modal-centered" : ""}`}
          open={open}
          onCancel={handleCancel}
          width={modalWidth}
          closeIcon={<ModalCloseIcon />}
          footer={null}
          centered
          transitionName=""
        >
          <div className="modal-content-wrapper">
            <Typography.Title className="modal-title">
              {modalTitle}
            </Typography.Title>

            {modalText && (
              <div className="modal-text-container">
                <Typography.Text className="modal-text">
                  {modalText}
                </Typography.Text>
              </div>
            )}

            <div className="modal-feedback">
              <LazyFeedbackForm onSuccess={handleFormSuccess} />
            </div>
          </div>
        </Modal>
      </ConfigProvider>
    </>
  );
}
